<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">实验室参考值列表</p>
      <span slot="extra">
        <Select v-model="siteid" style="width:120px" @on-change="fetchData" placeholder="请选择中心" clearable>
          <Option v-for="(site,key) in sites" :value="key" :key="key">{{ site }}</Option>
        </Select>
        <Select v-model="gender" style="width:120px" @on-change="fetchData" placeholder="请选择性别" clearable>
          <Option v-for="(gender,key) in genders" :value="key" :key="key">{{ gender }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 300px"></Input>
      </span>
      <Table stripe :columns="attributes" :data="lbs" v-if="lbs"></Table>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showEdit"
        title="编辑实验室参考值"
        :styles="{bottom:'0px'}" >
        <edit-lb ref="editLbRef" :meta="meta" @refresh="refresh"></edit-lb>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListLbRefs, GetAssistItems } from '@/api/lb.ref'
import EditLbRef from '@/components/lb/EditLbRef'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-lbs',
  data: function () {
    return {
      lbs: [],
      queryStr: '',
      meta: '',
      showEdit: false,
      pageMeta: {},
      siteid: null,
      sites: {},
      gender: null,
      genders: {},
      attributes: [{
        title: '研究中心',
        key: 'siteName'
      },
      {
        title: '性别',
        key: 'genderText'
      },
      {
        title: '检查项',
        key: 'varName'
      },
      {
        title: '下限',
        key: 'lower'
      },
      {
        title: '上限',
        key: 'upper'
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (h, params) => {
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-create-outline'
              },
              on: {
                click: () => {
                  this.edit(params.row.id)
                }
              }
            })
          ])
        }
      }]
    }
  },
  components: {
    'pagination': Pagination,
    'edit-lb': EditLbRef
  },
  created: function () {
    this.fetchData()
    this.getItems()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['LbRefSearch[siteid]'] = this.siteid
      query['LbRefSearch[gender]'] = this.gender
      query['LbRefSearch[studyid]'] = this.$route.params.id
      query['queryStr'] = this.queryStr
      ListLbRefs(query).then(async res => {
        this.lbs = res.items
        this.pageMeta = res._meta
      })
    },
    getItems: function () {
      GetAssistItems().then(async res => {
        this.sites = res.sites
        this.genders = res.genders
      })
    },
    refresh: function () {
      this.fetchData()
      this.showEdit = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editLbRef.init(id)
      this.showEdit = true
    }
  }
}
</script>
